import cn from "classnames"

import { Card, Link } from "@/atoms"
import { getPrProviderFromUrl, parsePrUrl } from "@/helpers/pr.helpers"
import { PullRequestOutlined, SourceControlIcon } from "@/icons"
import { IconText } from "@/molecules/IconText"

import styles from "./Action.module.scss"

import type { PullRequest } from "@/domain/issue"

interface PrCardProps {
  pr: PullRequest
  type?: "primary" | "secondary"
}

export const PrCard: React.FC<PrCardProps> = ({ pr, type }) => {
  const { label } = parsePrUrl(pr.url)
  const provider = getPrProviderFromUrl(pr.url)

  return (
    <Link href={pr.url} target="_blank" className={styles.link}>
      <Card
        className={
          type === "secondary"
            ? styles.actionCardSecondary
            : styles.actionCardPrimary
        }
      >
        <IconText
          Icon={
            provider
              ? (props) => (
                  <SourceControlIcon sourceControl={provider} {...props} />
                )
              : PullRequestOutlined
          }
          classes={{ container: styles.jiraInfo, icon: styles.icon }}
        >
          <span className={cn(styles.text, styles.textPadding)}>{label}</span>
        </IconText>
      </Card>
    </Link>
  )
}
